import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from './Button'
import '../nprogress.css'

import { MenuProps } from '../containers/ConnectedMenu'

const Menu: React.FC<MenuProps> = props => (
	<Fragment>
		<div className="grid">
			<div className="grid__row grid__row--spacing-top-3x grid__row--spacing-bottom-2x">
				<div className="grid__col grid__col--12">
					<div className="title title--align-center">
						<FormattedMessage
							id="greeting"
						/>
					</div>
				</div>
			</div>
		</div>

		<div className="grid__row grid__row--spacing-bottom-2x">
			<div className="grid__col grid__col--8 grid__col--spacing-2x grid__col--offset-2 grid__col--desktop-10 grid__col--offset-desktop-1 grid__col--mobile-landscape-12 grid__col--no-offset-mobile-landscape">
				<div className="grid__row">
					<div id="container" className="grid__col grid__col--spacing grid__col--4 grid__col--tablet-12">
						{props.assistantIsCalled && (
							<Button
								onClick={() => props.sendCallAssistant()}
								icon={''}
								busy={true}
								square={true}
							>
								<FormattedMessage id={'call-assistant-busy-button'} />
							</Button>
						)}
						{!props.assistantIsCalled && (
							<Button
								onClick={() => props.sendCallAssistant()}
								icon={props.assistantIsRequested === false ? 'fal fa-user-headset' : ''}
								busy={props.assistantIsRequested}
								square={true}
							>
								{props.assistantIsRequested
									? <i className="fad fa-spinner-third fa-spin" />
									: <FormattedMessage id={'call-assistant-button'} />
								}
							</Button>
						)}
					</div>
					<div className="grid__col grid__col--spacing grid__col--4 grid__col--tablet-12">
						<Button onClick={() => props.push('/scanner')} icon="fas fa-search" disabled={props.assistantIsRequested} square={true}>
							<FormattedMessage id="search-products-button" />
						</Button>
					</div>
					<div className="grid__col grid__col--spacing grid__col--4 grid__col--tablet-12">
						<Button onClick={() => { window.location.href = 'https://shop.futurestorearnhem.nl' }} icon="fas fa-shopping-cart" disabled={props.assistantIsRequested} square={true}>
							<FormattedMessage id="shop-button" />
						</Button>
					</div>
				</div>
			</div>
		</div>
	</Fragment>
)

export default Menu
